/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.anchorLink)();
	  (0, _module.toggleMenu)();
	  (0, _module.paraStory)();
	  (0, _module.letterSplit)();
	  (0, _module.scrollAnim)();
	  (0, _module.loadAnim)();
	  (0, _module.preImage)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resizeFv = exports.moviePlay = exports.preImage = exports.animParticle = exports.loadAnim = exports.scrollAnim = exports.letterSplit = exports.paraNormal = exports.paraStory = exports.msgStory = exports.loadingCloseAnv = exports.loadingClose = exports.mvSlider = exports.toggleMenu = exports.anchorLink = exports.tabletFlag = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width();
	
	function videoControl(action, target) {
	  var $playerWindow = $(target)[0].contentWindow;
	  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
	} // ------------------------------------------------------------------------
	// moviePlay
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var moviePlay = function moviePlay() {
	  if ($('.movie-wrapper').length) {
	    var trg = 0;
	    $(window).on("load", function () {
	      videoControl("playVideo", '#youtube-player');
	    });
	    $('.movie-wrapper, .st-Modal .close').on('click', function () {
	      $(".st-Modal").toggleClass("open");
	
	      if (trg == 0) {
	        videoControl("pauseVideo", '#youtube-player');
	        videoControl("playVideo", '#youtube-modal');
	        trg = 1;
	      } else if (trg == 1) {
	        videoControl("playVideo", '#youtube-player');
	        videoControl("stopVideo", '#youtube-modal');
	        trg = 0;
	      }
	    });
	  }
	}; // ------------------------------------------------------------------------
	// tabletFlag
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.moviePlay = moviePlay;
	
	var tabletFlag = function tabletFlag() {
	  $(window).on("load", function () {
	    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) {
	      if (window.innerHeight > window.innerWidth) {
	        $(".st-Modal").addClass("tablet");
	        $(".st-Loading").addClass("tablet");
	        $(".st-Firstview").addClass("tablet");
	      }
	    }
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.tabletFlag = tabletFlag;
	
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var toggleMenu = function toggleMenu() {
	  $('.st-Header .fixed .hamburger button').on('click', function () {
	    $(".st-Header .fixed .hamburger button").toggleClass("open");
	    $(".st-Header .fixed .hamburger").toggleClass("open");
	    $(".st-Header .fixed .fixed-body").toggleClass("open");
	    $(".st-Header .logo").toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// mvSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleMenu = toggleMenu;
	
	var mvSlider = function mvSlider() {
	  var slidenumber = $('#mvslide-main').data('is');
	  var dragSize = windowWidth / 768 * 64;
	  var slideMain = new Swiper('#mvslide-main', {
	    parallax: true,
	    resistanceRatio: 0,
	    speed: 200,
	    initialSlide: slidenumber,
	    navigation: {
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev'
	    },
	    scrollbar: {
	      el: '.swiper-scrollbar',
	      hide: false,
	      draggable: true,
	      dragSize: dragSize
	    }
	  });
	  var slideSub = new Swiper('#mvslide-sub', {
	    resistanceRatio: 0,
	    effect: 'fade',
	    initialSlide: slidenumber // allowTouchMove: false,
	
	  });
	  slideMain.on('slideChange', function () {
	    var idx = slideMain.realIndex;
	    $('.scrollbar-label').each(function (index, e) {
	      if (index == idx) {
	        $(e).addClass('current');
	      } else {
	        $(e).removeClass('current');
	      }
	    });
	  });
	  slideMain.controller.control = slideSub;
	  slideSub.controller.control = slideMain;
	}; // ------------------------------------------------------------------------
	// loadingClose
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.mvSlider = mvSlider;
	
	var loadingClose = function loadingClose() {
	  $(window).on("load", function () {
	    $(".st-Loading").addClass("change");
	    $(".st-Firstview").addClass("change");
	    $(".st-Container").removeClass("hidden");
	    setTimeout(function () {
	      $(".st-Loading").addClass("close");
	      $(".st-Firstview").addClass("close");
	      $(".st-Container").removeClass("fixed");
	      mvSlider();
	      setTimeout(function () {
	        $(".st-Loading").remove();
	        $(".st-Firstview").remove();
	        mvSlider();
	      }, 2000);
	    }, 3000);
	  });
	}; // ------------------------------------------------------------------------
	// loadingCloseAnv
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadingClose = loadingClose;
	
	var loadingCloseAnv = function loadingCloseAnv() {
	  $(window).on("load", function () {
	    $(".st-Loading").addClass("change");
	    $(".st-Firstview").addClass("change");
	    $(".st-Container").removeClass("hidden");
	  });
	  $('.st-Firstview .button-close').on('click', function () {
	    $(".st-Loading").addClass("close");
	    $(".st-Firstview").addClass("close");
	    $(".st-Container").removeClass("fixed");
	    mvSlider();
	    setTimeout(function () {
	      $(".st-Loading").remove();
	      $(".st-Firstview").remove();
	      mvSlider();
	    }, 2000);
	  });
	}; // ------------------------------------------------------------------------
	// paraNormal
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadingCloseAnv = loadingCloseAnv;
	
	var paraNormal = function paraNormal() {
	  $(window).on('load', function () {
	    var contHeight = $(".st-Container").outerHeight();
	    var scrollHeightL = "";
	    var scrollHeightS = "";
	
	    if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {
	      $(".sw-Particles").addClass("ipad");
	    }
	
	    if (matchMedia('(max-width: 798px)').matches) {
	      var scrollHeightL = contHeight / 500 * 75;
	      var scrollHeightS = contHeight / 500 * 50;
	    } else {
	      var scrollHeightL = contHeight / 500 * 105;
	      var scrollHeightS = contHeight / 500 * 65;
	    }
	
	    $(".sw-Particles").addClass("visible");
	    var controller = new ScrollMagic.Controller({
	      vertical: true
	    });
	    var tween = new TimelineMax().add([TweenMax.to(".sw-Particles span.particles-01", 1, {
	      backgroundPosition: "center -=" + scrollHeightL + "px"
	    }), TweenMax.to(".sw-Particles span.particles-02", 1, {
	      backgroundPosition: "center -=" + scrollHeightS + "px"
	    })]);
	    var scene = new ScrollMagic.Scene({
	      triggerElement: "body",
	      duration: contHeight,
	      offset: 0
	    }).setTween(tween).addTo(controller);
	  });
	}; // ------------------------------------------------------------------------
	// paraStory
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.paraNormal = paraNormal;
	
	var paraStory = function paraStory() {
	  $(window).on('load', function () {
	    var contHeight = $(".st-Container").outerHeight();
	    var scrollHeight = contHeight / 1000 * -7;
	    var controller = new ScrollMagic.Controller({
	      vertical: true
	    });
	    var tween = new TimelineMax().add([TweenMax.to(".str-Mainvisual .deco span.particles-01", 1, {
	      y: "-5%"
	    }), TweenMax.to(".str-Mainvisual .deco span.particles-02", 1, {
	      y: "-10%"
	    }), TweenMax.to(".str-Mainvisual_Inner .deco-inner span.particles-front", 1, {
	      y: "-20%"
	    }), TweenMax.to(".str-Detail_Inner .deco span.particles-03", 1, {
	      y: "-30%"
	    }), TweenMax.to(".str-Detail_Inner .deco span.particles-04", 1, {
	      y: "-20%"
	    })]);
	    var scene = new ScrollMagic.Scene({
	      triggerElement: "body",
	      duration: contHeight,
	      offset: 0
	    }).setTween(tween).addTo(controller);
	  });
	}; // ------------------------------------------------------------------------
	// msgStory
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.paraStory = paraStory;
	
	var msgStory = function msgStory() {
	  $(window).on('load', function () {
	    var contHeight = $(".st-Container").outerHeight();
	    var scrollHeight = contHeight / 1000 * -7;
	    var controller = new ScrollMagic.Controller({
	      vertical: true
	    });
	    var tween = new TimelineMax().add([TweenMax.to(".msg-Body .deco svg", 1, {
	      y: "-50%"
	    })]);
	    var scene = new ScrollMagic.Scene({
	      triggerElement: "body",
	      duration: contHeight,
	      offset: 0
	    }).setTween(tween).addTo(controller);
	  });
	}; // ------------------------------------------------------------------------
	// letterSplit
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.msgStory = msgStory;
	
	function spanWrap(tg) {
	  var target = document.querySelector(tg);
	  var nodes = target.childNodes;
	  var convert = [];
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var node = _step.value;
	
	      if (node.nodeType == 3) {
	        //テキストの場合
	        var text = node.textContent.replace(/\s+/g, '');
	        text.split('').forEach(function (v) {
	          convert.push("<span>" + v + "</span>");
	        });
	      } else {
	        convert.push(node.outerHTML);
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
	        _iterator["return"]();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  target.innerHTML = convert.join("");
	}
	
	var letterSplit = function letterSplit() {
	  $(window).on('load', function () {
	    spanWrap('.split-target_catch');
	    spanWrap('.split-target');
	  });
	}; // ------------------------------------------------------------------------
	// scrollAnim
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.letterSplit = letterSplit;
	
	var scrollAnim = function scrollAnim() {
	  $(window).on('scroll load', function () {
	    $('.js-sc').each(function () {
	      var targetPos = $(this).offset().top;
	      var scrollPos = $(window).scrollTop();
	      var windowHeight = $(window).height();
	
	      if (scrollPos > targetPos - windowHeight + windowHeight / 4) {
	        $(this).addClass("animated");
	      }
	    });
	  });
	}; // ------------------------------------------------------------------------
	// loadAnim
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.scrollAnim = scrollAnim;
	
	var loadAnim = function loadAnim() {
	  $(window).on('load', function () {
	    $('.js-ld').each(function () {
	      var target = $(this);
	      $(this).addClass("animated");
	      setTimeout(function () {
	        $(target).removeClass(" js-ld");
	      }, 400);
	    });
	  });
	}; // ------------------------------------------------------------------------
	// preImage
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.loadAnim = loadAnim;
	
	var preImage = function preImage() {
	  $(window).on('load', function () {
	    $(".lower").addClass("visible");
	  });
	}; // ------------------------------------------------------------------------
	// animParticle
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preImage = preImage;
	
	var animParticle = function animParticle() {
	  // PIXI.settings.CAN_UPLOAD_SAME_BUFFER = false;
	  var animParticles = function animParticles(target, img) {
	    var elm = document.getElementById(target);
	    var elmHeight = elm.clientHeight;
	    var windowWidth = window.innerWidth;
	    var windowHeight = window.innerHeight;
	    var mouse = {
	      x: 0,
	      y: 0
	    };
	    var exTrg = 0;
	    var exEndTrg = 0;
	    var beforePos = 0;
	    var app = new PIXI.Application({
	      width: windowWidth,
	      height: windowHeight,
	      transparent: true
	    });
	    app.stage.interactive = true;
	    elm.appendChild(app.view);
	    var sprites = new PIXI.ParticleContainer(100, {
	      scale: true,
	      position: true,
	      alpha: true,
	      autoResize: true,
	      rotation: true
	    }); // sprites.filterArea = new PIXI.Rectangle(0,0,2000,2000);
	    // let blur = new PIXI.filters.BlurFilter();
	    // sprites.filters = [blur];
	
	    app.stage.addChild(sprites);
	    var particles = [];
	    var spritesValue = '';
	
	    if (matchMedia('(max-width: 798px)').matches) {
	      spritesValue = 50;
	    } else {
	      spritesValue = 100;
	    }
	
	    var totalSprites = app.renderer instanceof PIXI.Renderer ? spritesValue : spritesValue;
	    var alphaflags = [];
	    var alphaflag;
	    var scaleflags = [];
	    var scaleflag;
	
	    for (var i = 0; i < totalSprites; i++) {
	      // create a new Sprite
	      var particle = PIXI.Sprite.from(img);
	      particle.tint = 0xb5f4ff; // var tl = new TimelineMax({ repeat: -1, yoyo: true })
	      //   .to(particle, 1, { pixi: { tint: 0xb5f4ff }})
	      //   .to(particle, 1, { pixi: { tint: 0xffb5d6 }});
	
	      particle.anchor.set(0.5);
	
	      if (windowWidth > 768) {
	        particle.scale.set(0.1 + Math.random() * 0.1);
	      } else {
	        particle.scale.set(0.1 + Math.random() * 0.1);
	      }
	
	      particle.x = Math.random() * app.screen.width;
	      particle.y = Math.random() * app.screen.height;
	      particle.direction = Math.random() * Math.PI * 2;
	      particle.turningSpeed = Math.random() - 0.8;
	      particle.speed = (2 + Math.random() * 2) * 0.5;
	      particle.offset = Math.random() * 100;
	      particle.alpha = Math.random() * 0.4;
	      particles.push(particle);
	      sprites.addChild(particle);
	      var _alphaflag = 2;
	      var _scaleflag = 2;
	      alphaflags.push(_alphaflag);
	      scaleflags.push(_scaleflag);
	    }
	
	    function onPointerMove(e) {
	      mouse.x = e.data.global.x;
	      mouse.y = e.data.global.y;
	    }
	
	    app.stage.on('mousemove', onPointerMove).on('touchmove', onPointerMove);
	    var particleBoundsPadding = 100;
	    var particleBounds = new PIXI.Rectangle(-particleBoundsPadding, -particleBoundsPadding, app.screen.width + particleBoundsPadding * 2, app.screen.height + particleBoundsPadding * 2);
	    var tick = 0;
	    var count = 0;
	    app.ticker.add(function () {
	      for (var _i = 0; _i < particles.length; _i++) {
	        var _particle = particles[_i]; // particle.filters = [new PIXI.filters.BlurFilter(5)]
	
	        _particle.direction += _particle.turningSpeed * 0.01;
	        _particle.x += Math.sin(_particle.direction) * 0.5;
	        _particle.y += Math.cos(_particle.direction) * 0.1 - 1;
	        _particle.rotation += Math.sin(_particle.direction) * (_particle.speed * _particle.scale.y) * 0.05; // particle.rotation = -particle.direction + Math.PI;
	        // opacity
	
	        if (_particle.alpha > 0.99) {
	          alphaflags[_i] = 1;
	        } else if (_particle.alpha < 0.05) {
	          alphaflags[_i] = 0;
	        }
	
	        if (alphaflags[_i] == 1) {
	          _particle.alpha -= 0.001 * _particle.speed;
	        } else if (alphaflags[_i] == 0 || alphaflags[_i] == 2) {
	          _particle.alpha += 0.001 * _particle.speed;
	        } // overflow
	
	
	        if (_particle.x < particleBounds.x) {
	          _particle.x += particleBounds.width;
	        } else if (_particle.x > particleBounds.x + particleBounds.width) {
	          _particle.x -= particleBounds.width;
	        }
	
	        if (_particle.y < particleBounds.y) {
	          _particle.y += particleBounds.height;
	        } else if (_particle.y > particleBounds.y + particleBounds.height) {
	          _particle.y -= particleBounds.height;
	        } // mouse
	
	
	        if (mouse.x - _particle.x < 50 && mouse.x - _particle.x > -50 && mouse.y - _particle.y < 50 && mouse.y - _particle.y > -50) {
	          _particle.x += (mouse.x - _particle.x) * _particle.speed * 0.01;
	          _particle.y += (mouse.y - _particle.y) * _particle.speed * 0.01;
	        }
	      }
	
	      tick += 0.1;
	    });
	    $(window).on("load resize", function () {
	      app.renderer.resize(window.innerWidth, window.innerHeight);
	      particleBounds.width = app.screen.width + particleBoundsPadding * 2;
	      particleBounds.height = app.screen.height + particleBoundsPadding * 2;
	    });
	    $(window).on("scroll", function () {
	      var scrollHeight = $(this).scrollTop();
	
	      for (var _i2 = 0; _i2 < particles.length; _i2++) {
	        var _particle2 = particles[_i2];
	
	        if (scrollHeight > beforePos) {
	          _particle2.y -= 6 * _particle2.scale.y;
	        } else {
	          _particle2.y += 6 * _particle2.scale.y;
	        }
	      }
	
	      beforePos = scrollHeight;
	    });
	  };
	
	  if (/iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document) {} else {
	    // animParticles('particles','/6th/assets/images/common/common/bg_particle.png');
	    if ($('#particles-load').length) {
	      animParticles('particles-load', './assets/images/common/common/bg_particle.png');
	    }
	
	    ;
	  }
	}; // ------------------------------------------------------------------------
	// resizeFv
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.animParticle = animParticle;
	
	var resizeFv = function resizeFv() {
	  $(window).on('resize load', function () {
	    if (matchMedia('(max-width: 798px)').matches) {
	      var dispWdt = window.innerWidth * 1.7;
	      var dispHgt = window.innerHeight;
	
	      if (dispHgt < dispWdt) {
	        $(".st-Firstview").addClass("resize");
	        $(".st-Firstview .chara").addClass("resize");
	        $(".st-Firstview .logo").addClass("resize");
	        $(".st-Firstview .movie-wrapper").addClass("resize");
	        $(".st-Firstview .button").addClass("resize");
	      } else {
	        $(".st-Firstview").removeClass("resize");
	        $(".st-Firstview .chara").removeClass("resize");
	        $(".st-Firstview .logo").removeClass("resize");
	        $(".st-Firstview .movie-wrapper").removeClass("resize");
	        $(".st-Firstview .button").removeClass("resize");
	      }
	    } else {
	      var _dispWdt = window.innerWidth * (8 / 16);
	
	      var _dispHgt = window.innerHeight;
	
	      if (_dispHgt < _dispWdt) {
	        $(".st-Firstview .chara").addClass("resize");
	        $(".st-Firstview .logo").addClass("resize");
	        $(".st-Firstview .movie-wrapper").addClass("resize");
	        $(".st-Firstview .button").addClass("resize");
	      } else {
	        $(".st-Firstview .chara").removeClass("resize");
	        $(".st-Firstview .logo").removeClass("resize");
	        $(".st-Firstview .movie-wrapper").removeClass("resize");
	        $(".st-Firstview .button").removeClass("resize");
	      }
	    }
	  });
	};
	
	exports.resizeFv = resizeFv;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// story/app.bundle.js